// extracted by mini-css-extract-plugin
export default {"footerStyle":"Footer_footerStyle__7s6pj","websiteRights":"Footer_websiteRights__veTwz"};